import React, { useEffect } from 'react'
import { theme } from 'theme'
import { FilterOrSortButton, MoveToListButton } from './ActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { selectFilterModel, setSearchTerm } from 'state/review'
import _ from 'lodash'
import Divider from 'components/Divider'
import { useNewTranslation, useDisplayTooltip } from 'hooks'
import { ToolTipNames } from 'hooks/displayTooltip'
import InfoTooltip from 'components/InfoTooltip'
import ApproveOrderTooltip from './ApproveOrderTooltip'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'
import { OptionsState } from 'particles/Dropdown'

interface WaitlistHeaderBarProps {
    onClickMoveBackToPending: any
    onClickMoveToPrioriyList: any
    disableMoveBackToPending?: boolean
    disableMoveToPrioriyList?: boolean
    hideApproveOrderButton?: boolean
    hideToolbar?: boolean
    className?: string
    onAddFilterField: (option: OptionsState) => void
    onAddSortField: (option: OptionsState) => void
}

const WaitlistHeaderBar: React.FC<WaitlistHeaderBarProps> = ({
    onClickMoveBackToPending,
    onClickMoveToPrioriyList,
    disableMoveBackToPending = false,
    disableMoveToPrioriyList = false,
    hideApproveOrderButton = false,
    hideToolbar,
    onAddFilterField,
    onAddSortField,
    className,
}) => {
    const [sortAndFilterTooltip, handleUpdateTooltipState] = useDisplayTooltip()
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const filterModel = useSelector(selectFilterModel)
    const noFilterApplied =
        !filterModel ||
        (filterModel && filterModel.items && filterModel.items.length === 0) ||
        (filterModel && filterModel.items && filterModel.items.every(item => _.isEmpty(item.value)))

    useEffect(() => {
        return () => {
            dispatch(setSearchTerm(''))
        }
    }, [])

    return (
        <div className={className}>
            <div className="table-title-block">
                <div className="title-block">
                    <Text scale="H4" color="primary">
                        {newT('submission.review.waitlistTableTitle')}
                    </Text>
                    <InfoTooltip label={newT('statusLabel.waitlistTooltipDescription')} iconColor="primary" />
                </div>
                <div className="tools">
                    <FilterOrSortButton
                        isActive={!noFilterApplied}
                        showList={sortAndFilterTooltip.current === ToolTipNames.GENERIC_FILTER}
                        onAddFilterField={onAddFilterField}
                        onClick={(e?: React.MouseEvent<HTMLElement>) => {
                            handleUpdateTooltipState(ToolTipNames.GENERIC_FILTER, e)
                        }}
                        anchorEl={sortAndFilterTooltip.anchorEl}
                    />
                    <FilterOrSortButton
                        isActive={!noFilterApplied}
                        showList={sortAndFilterTooltip.current === ToolTipNames.GENERIC_SORT}
                        onAddFilterField={onAddSortField}
                        isSort
                        onClick={(e?: React.MouseEvent<HTMLElement>) => {
                            handleUpdateTooltipState(ToolTipNames.GENERIC_SORT, e)
                        }}
                        anchorEl={sortAndFilterTooltip.anchorEl}
                    />
                    {hideApproveOrderButton ? null : <ApproveOrderTooltip />}
                </div>
            </div>
            <Divider mx={theme.spacing.xxs} mt={0} mb={theme.spacing.xxs} />

            {!hideToolbar && (
                <div className="tool-bar">
                    {onClickMoveBackToPending && (
                        <MoveToListButton
                            onClick={onClickMoveBackToPending}
                            isDisable={disableMoveBackToPending}
                            text={newT('button.moveBackToPending')}
                            iconSize="20px"
                        />
                    )}
                    {onClickMoveToPrioriyList && (
                        <MoveToListButton
                            onClick={onClickMoveToPrioriyList}
                            isDisable={disableMoveToPrioriyList}
                            text={newT('button.moveToPriorityList')}
                            isPriorityList
                        />
                    )}
                </div>
            )}
        </div>
    )
}

export default styled(WaitlistHeaderBar)`
    display: flex;
    flex-direction: column;
    .table-title-block {
        display: flex;
        align-items: center;
        padding: ${theme.spacing.xxs};
        justify-content: space-between;
    }
    .title-block,
    .tools {
        display: flex;
        align-items: center;
    }
    .tool-bar {
        display: flex;
        margin: 0 ${theme.spacing.xxs} 16px ${theme.spacing.xxs};
    }
`
